import { pageIntroContent } from '@insify/css/classes.module.css';
import { Button } from '@insify/design-system/components';
import { Plus } from '@insify/design-system/icons';

import { RichContentWithTooltip } from '../../../../components/RichContent';
import { WizardLayoutFormWithCommonSection } from '../../../../components/WizardLayoutForm';
import { usePastClaims, usePastClaimsDispatch } from '../../usePastClaims';
import { ClaimsOverviewList } from '../ClaimsOverviewList';

import * as styles from './ClaimsOverview.module.css';

import type { PastClaimsContent } from '../../PastClaims';

export const ClaimsOverview: React.FC<PastClaimsContent> = (props): JSX.Element => {
  const {
    richContent: { overview },
    translations,
  } = props;
  const { openPastClaimForm, submit } = usePastClaimsDispatch();
  const [state] = usePastClaims();

  return (
    <WizardLayoutFormWithCommonSection
      isSubmitting={Boolean(props.isSubmitting)}
      backCopy={translations.previous}
      onBack={props.onBack}
      forwardCopy={translations.overviewContinue}
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        submit(state.pastClaims);
      }}
    >
      <RichContentWithTooltip content={overview} className={pageIntroContent} />
      <ClaimsOverviewList {...props} />
      <Button
        kind='secondary'
        type='button'
        trackingId='add'
        onClick={() => openPastClaimForm(undefined)}
        className={styles.button}
        leftIcon={<Plus />}
      >
        {translations.overviewAddNewButtonCopy}
      </Button>
    </WizardLayoutFormWithCommonSection>
  );
};
